import { IEngineSection, useRuntimeEngineSections } from '@framework/engine';
import { useEffect } from 'react';
import { useModuleFormSectionsMonitorContext } from './ModuleFormSectionsMonitorContext';

export interface IModuleFormSectionsMonitorProps {
  sections: IEngineSection[];
}

/**
 * Sincronizza la visibilità delle sezioni con i valori del form.
 */
export function ModuleFormSectionsMonitor(
  props: IModuleFormSectionsMonitorProps,
) {
  const { sections } = props;

  const computedRuntimeSections = useRuntimeEngineSections(sections);
  const { setRuntimeSections } = useModuleFormSectionsMonitorContext();

  // Ricalcoliamo le sezioni, se sono cambiate e le settiamo nel context.
  // In questo modo sono accessibili dal Menu.
  useEffect(() => {
    setRuntimeSections(computedRuntimeSections);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [computedRuntimeSections]);

  return null;
}
